<template>
    <div class="summary-card">
        <AonCard>
            <div class="card-content">
                <div class="summary-details display-flex">
                    <div class="summary-left mr-lg">
                        <h6 class="mb-xs">About {{ entityStore.entity.name }}</h6>
                        <Description
                            :title="entityStore.entity.name"
                            :description="entityStore.entity.description"
                            :dark="false"
                        />
                    </div>
                    <div class="summary-right">
                        <div v-if="entityStore.entity.entity_type" class="meta">
                            <font-awesome-icon
                                icon="fas fa-flag"
                                class="text-stone-800 d-inline metric-icon mr-md"
                                size="lg"
                            />
                            <p class="text-stone-800 bold d-inline">
                                {{ entityStore.entity.entity_type }}
                            </p>
                        </div>
                        <div v-if="entityStore.entity.employee_count" class="meta">
                            <font-awesome-icon
                                icon="fas fa-people-group"
                                class="text-stone-800 d-inline metric-icon mr-md"
                                size="lg"
                            />
                            <p class="text-stone-800 bold d-inline">
                                {{ formatEmployeeCount(entityStore.entity.employee_count) }}
                            </p>
                        </div>
                        <div class="meta address display-flex flex-wrap">
                            <div
                                v-if="entityStore.entity.address"
                                class="text-stone-800 display-flex"
                            >
                                <font-awesome-icon
                                    icon="fas fa-map-marker-alt"
                                    class="text-stone-800 d-inline metric-icon mr-md"
                                    size="lg"
                                />
                                <p class="text-stone-800 bold">
                                    {{ entityStore.entity.address.replace(/,/g, ', ') }}
                                </p>
                            </div>
                        </div>
                        <div class="meta">
                            <font-awesome-icon
                                icon="fas fa-sack-dollar"
                                class="text-stone-800 d-inline metric-icon mr-md"
                                size="lg"
                            />
                            <p class="text-stone-800 d-inline bold">
                                {{ totalRevenue }} ({{ revenueYear ? revenueYear : 'N/A' }})
                            </p>
                        </div>
                        <div v-if="entityStore.entity.homepage_url" class="meta text-stone-800">
                            <font-awesome-icon
                                icon="fas fa-arrow-up-right-from-square"
                                class="text-stone-800 d-inline metric-icon mr-md"
                                size="lg"
                            />
                            <a
                                :href="entityStore.entity.homepage_url"
                                target="_blank"
                                class="p link d-inline"
                                style="font-weight: 700"
                            >
                                {{ entityStore.entity.homepage_url }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </AonCard>
    </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useEntityStore } from '@/stores'
import moment from 'moment'

import Description from '@/components/Description'

const entityStore = useEntityStore()
const filters = inject('filters')

const totalRevenue = computed(() => {
    return !entityStore.entity || !entityStore.entity.total_revenue
        ? null
        : `${filters.abbreviate(parseInt(entityStore.entity.total_revenue))}`
})

const revenueYear = computed(() => {
    if (entityStore.entity && entityStore.entity.total_revenue) {
        return moment(entityStore.entity.revenue_end_date).format('YYYY')
    }
    return null
})

const formatEmployeeCount = (count) => {
    if (!count) return null

    const hasPlus = count.toString().endsWith('+')
    const numberPart = parseInt(count.toString().replace('+', ''))

    return hasPlus ? `${numberPart.toLocaleString()}+` : numberPart.toLocaleString()
}
</script>

<style lang="scss" scoped>
.summary-card {
    width: 100%;
    position: relative;

    .summary-left,
    .summary-right {
        width: 50%;
    }

    .meta {
        margin-bottom: 15px;

        &:last-of-type {
            margin-bottom: 0;
        }

        .metric-icon {
            width: 25px;
        }
    }
}
</style>
